import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface HeadingProps {
  handleDownload: () => void;
}

function Heading({ handleDownload }: HeadingProps) {
  const { t } = useTranslation();
  const today = format(new Date(), t("date-format"));

  return (
    <div className="flex flex-col justify-between items-center gap-4 border-b p-5 lg:flex-row">
      <div className="flex flex-col gap-2">
        <div className="text-lg font-medium">{t("assessment-full-title")}</div>
        <div className="text-2xl font-bold">{t("free-assessment")}</div>
        <div className="flex gap-5">
          <span>
            {t("carry-on-date")}: {today}
          </span>
        </div>
      </div>
      <div className="flex gap-2">
        <Button onClick={() => handleDownload()}>
          {t("download-certificate")}
        </Button>
      </div>
    </div>
  );
}

export default Heading;
